import { useEffect, useState } from 'react';
import styled from 'styled-components';

import { ADSHeading, ADSPage, ADSPageLoading, ADSText } from '@aphrodite/common-ui';
import { useAuthHelper } from '@aphrodite/common/hooks';
import { firebaseAuth } from '@aphrodite/firebase/firebase';

import Navbar from '../components/Navbar';

// Styled Components
const StyledContainer = styled.div`
  display: flex;
  flex-flow: column nowrap;
  max-width: 100%;
  padding-left: 8%;
  padding-right: 8%;
  margin: auto;
  margin-top: 8%;
  @media only screen and (min-width: 680px) {
    width: 1000px;
    margin-top: 12%;
    padding: 0 4%;
  }
`;

export default function PageLogout(): React.ReactElement {
  const { user } = useAuthHelper();
  const [isLoggingOut, setIsLoggingOut] = useState(true);
  useEffect(() => {
    if (!user) {
      setIsLoggingOut(false);
    }
    firebaseAuth.signOut();
    setIsLoggingOut(false);
  }, [setIsLoggingOut, user]);
  if (isLoggingOut) {
    return <ADSPageLoading />;
  }
  return (
    <ADSPage>
      <Navbar />
      <StyledContainer>
        <ADSHeading hyphensNone={true}>You've successfully logged out!</ADSHeading>
        <br />
        <br />
        <ADSText>You may now close this page.</ADSText>
      </StyledContainer>
    </ADSPage>
  );
}
